import TherapistPublicListPage, {
  therapistPublicListGetStaticProps,
} from '@/legacy-src/components/TherapistPublicListPage'
import { getPublicTherapistSlugForLocale, PUBLIC_THERAPISTS_PAGE_SLUG } from '@/legacy-src/constants/locale.constants'

const PAGE_LOCALE = 'en'

const CURRENT_SLUG = getPublicTherapistSlugForLocale(PAGE_LOCALE)

const Page = TherapistPublicListPage

const isPathValidForLocale = PUBLIC_THERAPISTS_PAGE_SLUG === CURRENT_SLUG

export const getStaticProps = therapistPublicListGetStaticProps(isPathValidForLocale)

export default Page
